import * as React from 'react';
import {
  HelperTextSpan,
  HelperTextContainer,
  RightAlignedHelperTextSpan,
} from './HelperText.styles';
import type { HelperTextProps } from './HelperText.types';

const HelperText = React.forwardRef<HTMLSpanElement, HelperTextProps>(
  ({ text, type = 'right-aligned', className }: HelperTextProps, ref) =>
    type === 'right-aligned' ? (
      <HelperTextContainer className={className}>
        <RightAlignedHelperTextSpan ref={ref}>{text}</RightAlignedHelperTextSpan>
      </HelperTextContainer>
    ) : (
      <HelperTextSpan className={className} ref={ref}>
        {text}
      </HelperTextSpan>
    ),
);

HelperText.displayName = 'HelperText';

export default HelperText;
